import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "return-box export__return-box export__return-box--mobile" }
const _hoisted_2 = { class: "export" }
const _hoisted_3 = { class: "container export__container" }
const _hoisted_4 = { class: "return-box export__return-box export__return-box--desktop" }

import { onBeforeMount, ref } from 'vue'

import Layout from '@/app/components/Layout.vue'
import HeaderRoot from '@/app/components/header/Root.vue'
import ExportSettings from '@/app/components/export/ExportSettings.vue'
import { HeaderView } from '@/models/header'


export default /*@__PURE__*/_defineComponent({
  __name: 'Export',
  setup(__props) {

const view = ref<HeaderView | null>(null)

onBeforeMount(async () => {
  view.value = new HeaderView()
  await view.value.init()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(Layout, { hideMobileMenu: true }, {
    default: _withCtx(() => [
      _createVNode(HeaderRoot, { title: "Export" }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: { name: 'all_highlights' },
          class: "return-box__link"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "export__return-icon return-box__icon iconfont iprev" }, null, -1),
            _createTextVNode(" Back to Highlights ", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: { name: 'all_highlights' },
              class: "return-box__link"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "export__return-icon return-box__icon iconfont iprev" }, null, -1),
                _createTextVNode(" Back to Highlights ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createVNode(ExportSettings)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})